import React from 'react';
import { StyleSheet } from 'react-native';
import Summary from './Summary';
import { formatCurrency } from '../../utils/currency.utils';
import InvoiceHotelReceiptCard from './InvoiceHotelReceiptCard';
import RowView from '../RowView';
import Icon from '../Icon';
import BaseText from '../BaseText';
import { CommonProperties } from '../../styles';
import TitleSummaryList from '../tripSummary/TitleSummary';
import { useComponentTKey, i18nNS } from '../../i18n';
import { useTranslation } from 'react-i18next';
import {
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
} from '../../store/selectors/auth.selector';
import { useSelector } from 'react-redux';

const InvoiceHotelSummaryList = ({ response, passengers, onSelect }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('InvoiceHotelSummaryList');
  const currency = useSelector(selectCompanyCurrency);
  const currencyCulture = useSelector(selectCompanyCurrencyCulture);

  return (
    <>
      <TitleSummaryList
        desc={
          response.TotalNights +
          ' ' +
          (response.TotalNights === 1 ? t(tKey('Night')) : t(tKey('Nights')))
        }
        amount={formatCurrency(response.TotalCost, currency, currencyCulture, 2)}
        iconName="hotel"
      />
      <Summary>
        <InvoiceHotelReceiptCard
          item={response}
          passengers={passengers}
          disableDetails
          hidePrice
          onPress={onSelect}
        />
        <BaseText>
          {t(tKey('ReservedFor'))}: {response?.Passenger}
        </BaseText>
        <RowView style={styles.cancellation}>
          <Icon name="warning" />
          <BaseText> {t(tKey('OneNightPenalty'))} </BaseText>
        </RowView>
      </Summary>
    </>
  );
};
const styles = StyleSheet.create({
  cancellation: {
    backgroundColor: 'rgb(253,243,209)',
    ...CommonProperties.py3,
    marginTop: 15,
    justifyContent: 'center',
  },
});
export default InvoiceHotelSummaryList;
